/*
 * 412Vault "My Vault" wishlist (theme-native)
 * - Guests: localStorage on-device
 * - Logged-in: localStorage + server sync (Cloudflare Worker -> customer metafield)
 */
(function () {
  'use strict';

  var NS = (window.VaultWishlist = window.VaultWishlist || {});
  var GUEST_KEY = 'vault:wishlist';
  var customerId = NS.customerId || null;
  var STORE_KEY = customerId ? GUEST_KEY + ':' + customerId : GUEST_KEY;
  var VAULT_URL = '/pages/my-vault';
  var SYNC_URL = NS.syncUrl || '';
  var SIG = NS.sig || '';
  var canSync = !!(customerId && SYNC_URL && SIG && SYNC_URL.indexOf('REPLACE') === -1);

  var HEART_SVG =
    '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-heart" viewBox="0 0 24 24">' +
    '<path d="M22 8.862a5.95 5.95 0 0 1-1.654 4.13c-2.441 2.531-4.809 5.17-7.34 7.608-.581.55-1.502.53-2.057-.045l-7.295-7.562c-2.205-2.286-2.205-5.976 0-8.261a5.58 5.58 0 0 1 8.08 0l.266.274.265-.274A5.612 5.612 0 0 1 16.305 3c1.52 0 2.973.624 4.04 1.732A5.95 5.95 0 0 1 22 8.862z" stroke-linejoin="round"/></svg>';

  function parse(raw) {
    try { var v = JSON.parse(raw); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function read(key) {
    try { return parse(window.localStorage.getItem(key || STORE_KEY)); } catch (e) { return []; }
  }
  function persist(items) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(items)); } catch (e) {}
  }
  function write(items) {
    persist(items);
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }
  function indexOf(items, handle) {
    for (var i = 0; i < items.length; i++) { if (items[i] && items[i].handle === handle) return i; }
    return -1;
  }
  function has(handle) { return indexOf(read(), handle) > -1; }
  function toggle(entry) {
    var items = read();
    var i = indexOf(items, entry.handle);
    var added;
    if (i > -1) { items.splice(i, 1); added = false; } else { items.unshift(entry); added = true; }
    write(items);
    return added;
  }
  function mergeGuest() {
    if (!customerId) return;
    var guest = read(GUEST_KEY);
    if (!guest.length) return;
    var mine = read(STORE_KEY);
    var changed = false;
    guest.forEach(function (g) {
      if (g && indexOf(mine, g.handle) === -1) { mine.push(g); changed = true; }
    });
    if (changed) persist(mine);
    try { window.localStorage.removeItem(GUEST_KEY); } catch (e) {}
  }

  /* ---------- server sync (logged-in only) ---------- */
  function syncParams() {
    return '?cid=' + encodeURIComponent(customerId) + '&sig=' + encodeURIComponent(SIG);
  }
  function syncGet() {
    return fetch(SYNC_URL + syncParams(), { method: 'GET' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return d && Array.isArray(d.items) ? d.items : null; })
      .catch(function () { return null; });
  }
  function syncSend(items) {
    return fetch(SYNC_URL + syncParams(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
      keepalive: true
    }).catch(function () {});
  }
  var pushTimer = null;
  function syncPush() {
    if (!canSync) return;
    if (pushTimer) clearTimeout(pushTimer);
    pushTimer = setTimeout(function () { syncSend(read()); }, 300);
  }
  window.addEventListener('pagehide', function () {
    if (!canSync || !pushTimer) return;
    clearTimeout(pushTimer);
    pushTimer = null;
    syncSend(read());
  });
  function initSync() {
    if (!canSync) return;
    syncGet().then(function (server) {
      if (server == null) return;
      var local = read();
      var merged = server.slice();
      for (var i = 0; i < local.length; i++) {
        if (indexOf(merged, local[i].handle) === -1) merged.push(local[i]);
      }
      persist(merged);
      syncButtons();
      updateCounts();
      if (NS.page) NS.page.refresh();
      syncSend(merged);
    });
  }

  /* ---------- helpers ---------- */
  function handleFromUrl(url) {
    if (!url) return '';
    var m = url.split('/products/')[1];
    if (!m) return '';
    return m.split('?')[0].split('#')[0].split('/')[0];
  }
  function closestEl(el, sel) {
    el = el && el.nodeType === 3 ? el.parentElement : el;
    return el && el.closest ? el.closest(sel) : null;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(cents) {
    var n = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(NS.locale || undefined, { style: 'currency', currency: NS.currency || 'AUD' }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }

  function buildButton(d) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wishlist-btn wishlist-btn--' + (d.context || 'card');
    b.setAttribute('data-wishlist-toggle', '');
    b.setAttribute('data-wl-handle', d.handle || '');
    if (d.id) b.setAttribute('data-wl-id', d.id);
    if (d.variant) b.setAttribute('data-wl-variant', d.variant);
    b.setAttribute('data-wl-url', d.url || '');
    b.setAttribute('data-wl-title', d.title || '');
    b.setAttribute('data-wl-price', d.price || '');
    b.setAttribute('data-wl-image', d.image || '');
    b.setAttribute('aria-pressed', 'false');
    b.setAttribute('aria-label', 'Add ' + (d.title || 'product') + ' to My Vault');
    b.innerHTML = '<span class="wishlist-btn__icon">' + HEART_SVG + '</span><span class="wishlist-btn__label">Save</span>';
    return b;
  }
  function entryFromButton(btn) {
    return {
      handle: btn.getAttribute('data-wl-handle'),
      id: btn.getAttribute('data-wl-id') || null,
      variant: btn.getAttribute('data-wl-variant') || null,
      url: btn.getAttribute('data-wl-url') || '',
      title: btn.getAttribute('data-wl-title') || '',
      price: parseInt(btn.getAttribute('data-wl-price'), 10) || 0,
      image: btn.getAttribute('data-wl-image') || '',
      addedAt: Date.now()
    };
  }
  function paint(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = btn.querySelector('.wishlist-btn__label');
    if (label) label.textContent = active ? 'Saved' : 'Save';
    var title = btn.getAttribute('data-wl-title') || 'product';
    btn.setAttribute('aria-label', (active ? 'Remove ' + title + ' from My Vault' : 'Add ' + title + ' to My Vault'));
  }
  function syncButtons(scope) {
    var items = read();
    var btns = (scope || document).querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) {
      paint(btns[i], indexOf(items, btns[i].getAttribute('data-wl-handle')) > -1);
    }
  }
  function updateCounts() {
    var n = read().length;
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) { els[i].textContent = n; els[i].classList.toggle('is-empty', n === 0); }
  }

  function injectCards(scope) {
    var mounts = (scope || document).querySelectorAll('.product-item__image');
    for (var i = 0; i < mounts.length; i++) {
      var mount = mounts[i];
      if (mount.querySelector('[data-wishlist-toggle]')) continue;
      var card = closestEl(mount, '[data-grid-item]') || closestEl(mount, '.product-item');
      if (!card) continue;
      var linkEl = card.querySelector('a.product-link');
      var url = card.getAttribute('data-url') || (linkEl ? linkEl.getAttribute('href') : '');
      var handle = handleFromUrl(url);
      if (!handle) continue;
      var titleEl = card.querySelector('.product-item__title');
      var imgEl = mount.querySelector('img');
      var id = '';
      if (card.id) { var parts = card.id.split('-'); id = parts[parts.length - 1]; }
      var btn = buildButton({
        handle: handle, id: id, url: (url || '').split('?')[0],
        title: titleEl ? titleEl.textContent.trim() : '',
        image: imgEl ? imgEl.currentSrc || imgEl.src : '', context: 'card'
      });
      if (getComputedStyle(mount).position === 'static') mount.style.position = 'relative';
      mount.appendChild(btn);
    }
  }

  function injectPdp() {
    var pi = document.querySelector('product-info[data-product-handle]');
    if (!pi) return;
    var mount = pi.querySelector('.product__images') || pi.querySelector('product-images');
    if (!mount || mount.querySelector('[data-wishlist-toggle]')) return;
    if (getComputedStyle(mount).position === 'static') mount.style.position = 'relative';
    var handle = pi.getAttribute('data-product-handle');
    var titleEl = document.querySelector('.product-single__title, .product__title, .product-title, h1');
    var imgEl = mount.querySelector('img');
    var btn = buildButton({
      handle: handle, id: pi.getAttribute('data-product-id') || '',
      url: pi.getAttribute('data-url') || '/products/' + handle,
      title: titleEl ? titleEl.textContent.trim() : (document.title || ''),
      image: imgEl ? imgEl.currentSrc || imgEl.src : '', context: 'pdp'
    });
    mount.appendChild(btn);
    syncButtons(mount);
  }

  function injectHeader() {
    var groups = [
      { sel: '.header__desktop__buttons', cls: 'header__desktop__button' },
      { sel: '.header__mobile__right', cls: 'header__mobile__button' }
    ];
    for (var g = 0; g < groups.length; g++) {
      var containers = document.querySelectorAll(groups[g].sel);
      for (var c = 0; c < containers.length; c++) {
        var container = containers[c];
        if (container.querySelector('.header__wishlist-link')) continue;
        var cls = groups[g].cls;
        var accountBtn = null;
        var links = container.querySelectorAll('a[href]');
        for (var i = 0; i < links.length; i++) {
          var href = links[i].getAttribute('href') || '';
          if (/\/account(\/|\?|$)/.test(href)) { accountBtn = closestEl(links[i], '.' + cls) || links[i].parentElement; break; }
        }
        var wrap = document.createElement('div');
        wrap.className = cls + ' header__wishlist-link-wrap';
        wrap.innerHTML = '<a href="' + VAULT_URL + '" class="navlink header__wishlist-link" title="My Vault"><span class="header__wishlist-icon">' + HEART_SVG + '<span class="header__wishlist-count is-empty" data-wishlist-count aria-hidden="true">0</span></span><span class="visually-hidden">My Vault</span></a>';
        if (accountBtn && accountBtn.parentNode) { accountBtn.parentNode.insertBefore(wrap, accountBtn.nextSibling); }
        else { container.insertBefore(wrap, container.firstChild); }
      }
    }
    updateCounts();
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var prev = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); }).then(function () { window.location.href = '/cart'; })
      .catch(function () { btn.disabled = false; btn.textContent = prev || 'Add to cart'; });
  }

  document.addEventListener('click', function (e) {
    var btn = closestEl(e.target, '[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    paint(btn, toggle(entryFromButton(btn)));
  }, true);

  document.addEventListener('wishlist:updated', function () {
    syncButtons();
    updateCounts();
    if (NS.page) NS.page.refresh();
    syncPush();
  });
  window.addEventListener('storage', function (e) {
    if (e.key === STORE_KEY) { syncButtons(); updateCounts(); if (NS.page) NS.page.refresh(); }
  });

  function initPage() {
    var root = document.querySelector('[data-wishlist-root]');
    if (!root) return;
    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var loading = root.querySelector('[data-wishlist-loading]');

    function actionHTML(p) {
      if (!p.available) { return '<button type="button" class="btn wishlist-card__action" disabled>Sold out</button>'; }
      if (p.variants && p.variants.length === 1) { return '<button type="button" class="btn wishlist-card__action" data-wishlist-add="' + p.variants[0].id + '">Add to cart</button>'; }
      var opts = '<option value="">Select size</option>';
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        opts += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + escapeHtml(v.title) + (v.available ? '' : ' - Sold out') + '</option>';
      }
      return '<div class="wishlist-card__buy"><select class="wishlist-card__select" data-wishlist-select aria-label="Select size">' + opts + '</select><button type="button" class="btn wishlist-card__action" data-wishlist-add-selected disabled>Add to cart</button></div>';
    }

    function cardHTML(row) {
      var it = row.entry;
      var p = row.product;
      if (!p) {
        return '<div class="wishlist-card wishlist-card--gone"><div class="wishlist-card__body"><p class="wishlist-card__title">' + escapeHtml(it.title || 'Product') + '</p><p class="wishlist-card__note">No longer available</p><button type="button" class="btn wishlist-card__action" data-wishlist-remove="' + escapeHtml(it.handle) + '">Remove</button></div></div>';
      }
      var img = p.featured_image || it.image || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var url = '/products/' + p.handle;
      return '<div class="wishlist-card" data-handle="' + escapeHtml(p.handle) + '"><a class="wishlist-card__image" href="' + url + '">' + (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</a><button type="button" class="wishlist-card__remove" data-wishlist-remove="' + escapeHtml(p.handle) + '" aria-label="Remove ' + escapeHtml(p.title) + ' from My Vault">&times;</button><div class="wishlist-card__body"><a class="wishlist-card__title" href="' + url + '">' + escapeHtml(p.title) + '</a><p class="wishlist-card__price">' + formatMoney(p.price) + '</p>' + actionHTML(p) + '</div></div>';
    }

    function render() {
      var items = read();
      if (loading) loading.hidden = true;
      if (!items.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
      if (empty) empty.hidden = true;
      Promise.all(items.map(function (it) {
        return fetch('/products/' + it.handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { return { entry: it, product: p }; }).catch(function () { return { entry: it, product: null }; });
      })).then(function (rows) { grid.innerHTML = rows.map(cardHTML).join(''); });
    }

    root.addEventListener('change', function (e) {
      var sel = closestEl(e.target, '[data-wishlist-select]');
      if (!sel) return;
      var card = closestEl(sel, '.wishlist-card');
      var btn = card ? card.querySelector('[data-wishlist-add-selected]') : null;
      if (btn) btn.disabled = !sel.value;
    });

    root.addEventListener('click', function (e) {
      var rm = closestEl(e.target, '[data-wishlist-remove]');
      if (rm) {
        e.preventDefault();
        var handle = rm.getAttribute('data-wishlist-remove');
        var items = read();
        var idx = indexOf(items, handle);
        if (idx > -1) { items.splice(idx, 1); write(items); }
        return;
      }
      var addSel = closestEl(e.target, '[data-wishlist-add-selected]');
      if (addSel) {
        e.preventDefault();
        var card = closestEl(addSel, '.wishlist-card');
        var sel = card ? card.querySelector('[data-wishlist-select]') : null;
        addToCart(sel ? sel.value : '', addSel);
        return;
      }
      var add = closestEl(e.target, '[data-wishlist-add]');
      if (add) { e.preventDefault(); addToCart(add.getAttribute('data-wishlist-add'), add); }
    });

    NS.page = { refresh: render };
    render();
  }

  var scanQueued = false;
  function scan() { scanQueued = false; injectCards(document); injectPdp(); injectHeader(); syncButtons(); }
  function queueScan() { if (scanQueued) return; scanQueued = true; (window.requestAnimationFrame || window.setTimeout)(scan); }

  NS.read = read;
  NS.has = has;
  NS.toggle = toggle;

  function boot() {
    mergeGuest();
    injectCards(document);
    injectPdp();
    injectHeader();
    syncButtons();
    updateCounts();
    initPage();
    initSync();
    if (window.MutationObserver && document.body) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) { if (muts[i].addedNodes && muts[i].addedNodes.length) { queueScan(); break; } }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
